"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _themeUi = require("theme-ui");
var _react = require("react");

/** @jsx jsx */
var TextInput = (0, _react.forwardRef)(function (props, ref) {
  return (0, _themeUi.jsx)(_themeUi.Input, (0, _tslib.__assign)({
    as: "input",
    id: props.id,
    type: props.type
  }, props.field, {
    ref: ref,
    name: props.field && props.field.name || props.name,
    value: props.field && props.field.value || props.value
  }, props));
});
TextInput.displayName = 'TextInput';
TextInput.defaultProps = {
  type: 'text'
};
var _default = TextInput;
exports.default = _default;